import type { OrderInfo } from '@@partner:types:app'
import type { GQL_ID } from '@@partner:types:graphql'

import { gql, useMutation } from '@apollo/client'

export interface PlaceOrderMutation {
  updated: OrderInfo
}
export interface PlaceOrderMutationVariables {
  order_id: GQL_ID
  isUpdatePlacing?: boolean
}

export const GQL_MUTATION_PLACE_ORDER = gql`
  mutation($order_id: ID!, $isUpdatePlacing: Boolean) {
    updated: placeOrder(
      order_id: $order_id
      isUpdatePlacing: $isUpdatePlacing
    ) {
      id
      status
    }
  }
`

export function usePlaceOrder () {
  return useMutation<PlaceOrderMutation, PlaceOrderMutationVariables>(
    GQL_MUTATION_PLACE_ORDER
  )
}
